//#region Angular Imports

import { IServiceProvider, IRootScopeService } from 'angular'

//#endregion

//#region Util Imports

import * as _ from 'underscore'

//#endregion

//#region Helper Imports

import { LogHelper, EventsNames } from '../../helpers'
import { DataProviderRequest, DataProviderRequestError } from '../../data-provider'

//#endregion

//#region Model

import { OpAlarmEvent } from '../../models/dw'

//#endregion

//#region Service Imports

import { UserSessionService, USER_SESSION_SERVICE_NAME } from '../user-session'
import { $ROOT_SCOPE_SERVICE_NAME } from '../system'

//#endregion

//#region Public Types

export const ALARM_SERVICE_NAME = 'AlarmService'
export const ALARM_SERVICE_PROVIDER_NAME = 'AlarmServiceProvider'

//#endregion


export class AlarmService {

    //#region Consts

    private readonly LOG_PREFIX = '[SIMAX.Module.Alarm]'

    //#endregion

    //#region Ctor

    public constructor(private readonly $rootScope: IRootScopeService, private readonly userSessionService: UserSessionService) { }

    //#endregion

    //#region Confirm

    public confirmAlarm(idAlarms: ReadonlyArray<number>): DataProviderRequest<OpAlarmEvent[]> {
        const request = this.userSessionService
            .getDataProvider()
            .AlarmEvent
            .confirmAlarmEvent(idAlarms)

        request.then(() => {
            this.$rootScope.$broadcast(EventsNames.ALARM_APPROVED, _.size(idAlarms))
        })

        request.catch((error: DataProviderRequestError) => {
            LogHelper.warn(this.LOG_PREFIX, `Unable to confirm alarm: ${idAlarms}`, error.toString())
        })

        return request
    }

    //#endregion
}


export class AlarmServiceProvider implements IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [
        $ROOT_SCOPE_SERVICE_NAME, USER_SESSION_SERVICE_NAME, ($rootScope: IRootScopeService, userSessionService: UserSessionService) => {
            return new AlarmService($rootScope, userSessionService);
        }]

    //#endregion
}  